<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> {{ title }}</strong>
          </div>
          <b-form>
            <b-form-group label="Segment" label-for="basicSelect">
              <b-form-select
                id="basicSelect"
                :plain="true"
                :options="segmentOptions"
                v-model="selectedSegment">
              </b-form-select>
              <span class="field-error">{{ errors.segment }}</span>
            </b-form-group>
            <b-form-group label='Date début' label-for='date_debut'>
              <b-form-input id='date_debut' type='date'
                          :class="{hasError: errors.date_debut !== ''}"
                          v-model="date_debut">
              </b-form-input>
              <span class='field-error'>{{ errors.date_debut }}</span>
            </b-form-group>
            <b-form-group label='Date fin' label-for='date_fin'>
              <b-form-input id='date_fin' type='date'
                          :class="{hasError: errors.date_fin !== ''}"
                          v-model="date_fin">
              </b-form-input>
              <span class='field-error'>{{ errors.date_fin }}</span>
            </b-form-group>
            <b-form-group label="Commentaire" label-for="commentaire">
              <b-form-textarea
                id="commentaire"
                type="text"
                :class="{hasError: errors.commentaire !== ''}"
                rows="4"
                v-model="commentaire">
              </b-form-textarea>
              <span class="field-error">{{ errors.commentaire }}</span>
            </b-form-group>
            <div class="mt-5" slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"/> Liste des consignes
              </b-button>
              <b-button type="button" @click="edit" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"/> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {isEmpty} from "@/utils/fileHelper";

  export default {
    name: "Edit",
    data() {
      return {
        id: null,
        selectedSegment: null,
        date_debut: '',
        date_fin: '',
        commentaire: '',
        title: '',
        segmentOptions: [],
        errors: {
          commentaire: '',
          segment: '',
          date_debut: "",
          date_fin: "",
        },
      }
    },
    mounted() {
      this.getSegments();
      if (!isEmpty(this.$route.query.id)) {
        this.id = this.$route.query.id;
        this.getConsigneSegment();
        this.title = 'Modification de la consigne';
      } else {
        this.title = 'Création d\'une nouvelle consigne segment';
      }
      
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      // this.getFamillesProduits();
    },
    methods: {
      getConsigneSegment() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceGestion/consignes-segment/' + this.id)
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            this.selectedSegment = response.data.consigne.segment_id;
            this.commentaire = response.data.consigne.commentaire;
            this.date_debut = response.data.consigne.date_debut;
            this.date_fin = response.data.consigne.date_fin;
          })
          .catch(() => {
            this.handleError(this);
          });
      },
      getSegments() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceGestion/dossier/getAllSegment')
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            const segments = response.data.data;
            for (let i = 0; i < segments.length; i++) {
              this.segmentOptions.push({
                text: segments[i].libelle,
                value: segments[i].id
              });
            }
          })
          .catch(() => {
            this.handleError(this);
          });
      },
      edit() {
        // console.log('this.validateData()', this.validateData())
        if (this.validateData()) {
          this.$store.commit('IS_LOADING', true);
          let dataPost = {};
          dataPost.segmentId = this.selectedSegment;
          dataPost.date_debut = this.date_debut;
          dataPost.date_fin = this.date_fin;
          dataPost.commentaire = this.commentaire;
          dataPost.consigneId = this.id;
          this.$axios
            .post('/espaceGestion/consignes-segment', dataPost)
            .then(() => {
              this.$store.commit('IS_LOADING', false);
              let title = isEmpty(this.id) ? 'Création avec succès' : 'Modification avec succès';
              let text = isEmpty(this.id) ? 'La consigne a bien été créée.' : 'La consigne a bien été modifiée.';
              this.$swal({
                position: 'top',
                type: 'success',
                title: title,
                text: text,
                showConfirmButton: false,
                timer: 5000
              });
              this.returnBack()
            })
            .catch(() => {
              this.handleError(this);
            });
        }
      },
      returnBack() {
        this.$router.push({path: '/espace-gestion/consignes-segment/list'});
      },
      validateData() {
        this.clearErrors()
        let dateFrom = new Date(this.date_debut)
        let dateTo = new Date(this.date_fin)
        let valid = true;

        if (this.selectedSegment === null) {
          this.errors.segment = 'Le segment est obligatoire';
          valid = false;
        }

        if (isEmpty(this.commentaire)) {
          this.errors.commentaire = 'Vous devez saisir une consigne';
          valid = false;
        }

        if (!this.date_debut) {
            this.errors.date_debut = "La date de début est obligatoire"
            valid= false;
        }
        if (!this.date_fin) {
            this.errors.date_fin = "La date de fin est obligatoire"
            valid= false;
        }
        if (this.date_fin !== null && this.date_fin !== "") {
          if (dateTo.getTime() < dateFrom.getTime()) {
            this.errors.date_fin = "La date de fin doit être postérieure à la date de début"
            valid= false;
          }
        }

        return valid;
      },
      clearErrors() {
        this.errors.segment = '';
        this.errors.commentaire = '';
        this.errors.date_fin = "";
      },
      handleError(self) {
        self.$store.commit('IS_LOADING', false);
        self.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support Dosi.',
          showConfirmButton: false,
          timer: 5000
        });
      }
    }
  }
</script>
